import firebase from "firebase";

const config = {
  apiKey: "AIzaSyAnnh0-G8qmMBRl6m8fcuHr3e3M_4SXp00",
  authDomain: "updiet-app.firebaseapp.com",
  databaseURL: "https://updiet-app.firebaseio.com",
  projectId: "updiet-app",
  storageBucket: "updiet-app.appspot.com",
  messagingSenderId: "69450769000",
  appId: "1:69450769000:web:d3b9d949225e0ff65851dd",
  measurementId: "G-LFMT363F5Y"
};

const firebaseApp = firebase.initializeApp(config);
export default firebaseApp.firestore();